import { render, staticRenderFns } from "./bwlistPanel.vue?vue&type=template&id=44258bf6&"
import script from "./bwlistPanel.vue?vue&type=script&lang=js&"
export * from "./bwlistPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports